import { render, staticRenderFns } from "./voices.vue?vue&type=template&id=14907d64&scoped=true"
import script from "./voices.vue?vue&type=script&lang=js"
export * from "./voices.vue?vue&type=script&lang=js"
import style0 from "./voices.vue?vue&type=style&index=0&id=14907d64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14907d64",
  null
  
)

export default component.exports